import React from "react"
import { isEmpty } from "lodash-es"
import { useFormSubmissionAuditTrailContext } from "contexts/FormSubmissionAuditTrailContext"
import StrikeAround from "shared/StrikeAround"
import LoadingIndicator from "shared/LoadingIndicator"
import AuditList from "./AuditList"

const FormSubmissionAuditTrailGroups = () => {
  const { auditGroups, isLoading, page } = useFormSubmissionAuditTrailContext()

  if (isLoading && page === 1) {
    return (<LoadingIndicator textValue="Loading audits ..." />)
  }

  if (isEmpty(auditGroups) && !isLoading) {
    return (
      <p className="text-center mb-12">
        There are no audits with the selected options.
      </p>
    )
  }

  return (
    <>
      {
        Object.entries(auditGroups).map(([formattedDate, audits]) => (
          <div key={formattedDate} className="mb-8">
            <StrikeAround className="mb-9">
              <span className="font-medium text-xl" aria-hidden>{ formattedDate }</span>
            </StrikeAround>
            <AuditList audits={audits} />
          </div>
        ))
      }
      {
        isLoading
        && <LoadingIndicator />
      }
    </>
  )
}

export default FormSubmissionAuditTrailGroups
